export enum EProtocolNoteStatus {
	ACTIVE = "active",
	ARCHIVED = "archived",
}

/** Uniquement valable en filtre de liste : une note n'est jamais dans cet état. */
export const PROTOCOL_NOTE_STATUS_ALL = "all";

export type ProtocolNoteStatusFilter = EProtocolNoteStatus | typeof PROTOCOL_NOTE_STATUS_ALL;
